import * as React from "react";

const perguntaFoiRespondida = (pergunta) => {
    if (typeof pergunta.resposta === "string") {
        return pergunta.resposta.trim().length > 0;
    }

    return pergunta.resposta !== null && pergunta.resposta !== undefined;
};

export const obterProgresso = (grupos = []) => {
    return grupos.reduce((progresso, grupo) => {
        const perguntas = grupo.listResultadoFormulario || [];
        const subgrupos = grupo.listaDeGrupoDePerguntaFilho || [];

        progresso.total += perguntas.length;
        progresso.respondidas += perguntas.filter(perguntaFoiRespondida).length;

        const progressoDosSubgrupos = obterProgresso(subgrupos);
        progresso.total += progressoDosSubgrupos.total;
        progresso.respondidas += progressoDosSubgrupos.respondidas;

        return progresso;
    }, { total: 0, respondidas: 0 });
};

const ProgressoDoPreenchimento = ({ listaDeGruposDePerguntas }) => {
    const { total, respondidas } = obterProgresso(listaDeGruposDePerguntas);
    const percentual = total > 0 ? Math.round((respondidas / total) * 100) : 0;

    return (
        <section className="d-flex flex-column flex-md-row">
            <div className="m-4 p-3 d-flex align-items-center justify-content-center flex-column rounded" style={{ boxShadow: '0 0 0.4rem var(--ws-blue-soft)' }}>
                <h3>{respondidas} de {total}</h3>
                <p className="mb-0">Progresso do Preenchimento</p>
            </div>

            <div className="m-4 p-3 d-flex align-items-center justify-content-center flex-column rounded" style={{ boxShadow: '0 0 0.4rem var(--ws-blue-soft)' }}>
                <h3>{percentual}%</h3>
                <p className="mb-0">Conclusão do Formulário</p>
            </div>
        </section>
    );
};

export default ProgressoDoPreenchimento;
